"use strict";

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StubCacheService = void 0;

var MockCacheService_1 = require("../mock/MockCacheService");

var StubCacheService = /*#__PURE__*/function (_MockCacheService_1$M) {
  _inherits(StubCacheService, _MockCacheService_1$M);

  function StubCacheService() {
    _classCallCheck(this, StubCacheService);

    return _possibleConstructorReturn(this, _getPrototypeOf(StubCacheService).apply(this, arguments));
  }

  return StubCacheService;
}(MockCacheService_1.MockCacheService);

exports.StubCacheService = StubCacheService;